"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var LinkDropdown =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(LinkDropdown, _Component);

  function LinkDropdown() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LinkDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LinkDropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: false
    };

    _this.toggle = function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    };

    return _this;
  }

  (0, _createClass2.default)(LinkDropdown, [{
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.state.open && this.setState({
        open: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          disabled = _this$props.disabled;
      return _react.default.createElement("div", {
        className: "btn-group".concat(open ? ' open' : '', " ").concat(className),
        style: style
      }, _react.default.createElement("a", {
        disabled: !children || !_react.default.Children.count(children) || disabled,
        onClick: this.toggle,
        className: "dropdown-toggle",
        style: {
          cursor: 'pointer'
        }
      }, title, " ", _react.default.createElement("span", {
        className: "caret"
      })), _react.default.createElement("ul", {
        className: "dropdown-menu",
        onClick: this.toggle
      }, _react.default.Children.map(children, function (child, i) {
        if (!child) {
          return null;
        }

        if (child.type === 'hr') {
          return _react.default.createElement("li", {
            className: "divider",
            key: i
          });
        }

        return _react.default.createElement("li", {
          className: "dropdown-item".concat(child.props.disabled ? ' disabled' : ''),
          key: i,
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        }, child);
      })));
    }
  }]);
  return LinkDropdown;
}(_react.Component);

LinkDropdown.defaultProps = {
  disabled: false,
  className: ''
};

var _default = (0, _reactClickOutside.default)(LinkDropdown);

exports.default = _default;